import { ClassicPreset, GetSchemes, NodeEditor } from 'rete';
import { AreaPlugin } from 'rete-area-plugin';
import { AreaExtra, Schemes } from '../rete/helperRete';
import { RedirectControl } from '../controls/redirectControl';
import { MessageService } from '../../../../../../../common/infrastructure/servicios';
import { MessageType } from '../../../../../../../common/infrastructure/servicios/MessageService';
import { Router, useRouter } from 'vue-router';
import { IapComponent } from '../../../../../component/domain/iapComponent';
import { CustomMenu } from '../../../../../../../common/domain/modelos/menu/CustomMenu';
import { searchMenuTree } from '../../../../../menu/infrastructure/HelperMenu';


export class RedirectNode extends ClassicPreset.Node<
  { ejecutar: ClassicPreset.Socket },
  { ejecutar: ClassicPreset.Socket, value: ClassicPreset.Socket },
  { value: RedirectControl }
> {
  height = 220;
  width = 180;

  private value: Number;
  private selectedValue: Number;
  private area: AreaPlugin<Schemes, AreaExtra>;
  private updateNode: any;
  private rdControlId: '';
  private router:Router;
  private componentData: IapComponent[]
  private store :any;

  constructor(area: AreaPlugin<Schemes, AreaExtra>, socket: ClassicPreset.Socket, selectedValue: Number, updateNode: any = undefined,router:Router,storeInput:any,componentDataInput: IapComponent[]) {
    super("Redirect");
    this.selectedValue = selectedValue;
    this.area = area;
    this.updateNode = updateNode;
    this.value = selectedValue;
    this.router=router;
    this.componentData = componentDataInput;
    this.store = storeInput;
    const dsControl = new RedirectControl(selectedValue, this.updateData);

    this.rdControlId = (dsControl as any).id;

    this.addInput("ejecutar", new ClassicPreset.Input(socket, "Ejecutar", true));
    this.addControl(
      "value",
      dsControl

      //new ClassicPreset.InputControl("text", { initial })
    );

    this.addOutput("ejecutar", new ClassicPreset.Output(socket, "Ejecutar"));


    //area.update("control",dsControl.id)
    this.addOutput("value", new ClassicPreset.Output(socket, "Valor"));





  }

  updateData = (evt: any) => {
    this.value = evt
    this.controls['value'].value = evt;

    this.area.update("control", this.rdControlId)

    if (this.updateNode) {
      this.updateNode(this.id, 'value', this.value,true, false)
    }

  }



  async execute(input: "ejecutar", forward: (output: "ejecutar") => void) {

    const cusMenus = this.store.getters.getApplicationMenus as CustomMenu[];
    
    if (cusMenus)
    {
      const menu = searchMenuTree(cusMenus,this.selectedValue) as CustomMenu
      if (menu && menu?.route)
      {
        const _route = (menu?.route ?? '/')
        this.router.push({ path: _route as any });
      }
    }

    forward("ejecutar");

  }


  data(): { value: Number } {
    return {
      value: this.controls.value.value ?? -1
    };
  }
}